// extracted by mini-css-extract-plugin
export default {"addForm":"addFlightForm_addForm__rlun5","label":"addFlightForm_label__yDTan","desc":"addFlightForm_desc__JQrhn","groupButton":"addFlightForm_groupButton__Hsbkn"};